/******************************************
*  Author : Riccardo Di Dato
*  Created On : Fri Mar 08 2024
*  File : ForkProcess.ts
*******************************************/
/**
 * Questo metodo effettua il fork in un nuovo processo in fire and forget
 * @param f
 */
export function forkProcess(f) {
    /*
     * Utilizzare un request animation frame impone al browser di passare alla fase di rendering, eseguendo un setTimeout al suo interno
     * imponiamo che al termine del della fase di rendering sarà eseguito un nuovo task
     * Questa gestione forza il paint prima dell'esecuzione del processo da forkare, facendo in modo che non contribuisca all'INP
     */
    requestAnimationFrame(() => {
        setTimeout(f, 0);
    });
}
/**
 * Questo metodo effettua il fork in un nuovo processo permettendo di fare join attraverso una promise
 * @param f
 */
export function forkProcessWithJoin(f) {
    return new Promise((resolve, reject) => {
        forkProcess(() => {
            try {
                f();
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    });
}
